import React, { useEffect } from 'react';
import './style.css';
import { useRecoilValue } from 'recoil';
import { informationAtom } from '../../../store/InformationStore';
import { useNavigate } from 'react-router-dom';
import Lottie from 'react-lottie';
import * as successLogo from '../../../assets/images/Success.json';
import parse from 'html-react-parser';
import { getRow } from './Rows';
import { endSimulation } from '../../../api/ifec-verify-services/IfecVerifyService';

const TimeLine = ({ rightPanelLang = 'tr' }) => {
    const navigate = useNavigate();
    const information = useRecoilValue(informationAtom);
    const [result, setResult] = React.useState(0);
    const [step, setStep] = React.useState(0);
    const [finish, setFinish] = React.useState(false);

    const getActive = () => {
        if (information.simulationStep === 4 && information.simulationNumber === 11) {
            finishSimulation();
        }

        setStep(information.simulationStep);
        setResult(information.simulationNumber);
    };

    useEffect(() => {
        getActive();
    }, [information.simulationNumber, information.simulationStep]);

    useEffect(() => {
        if (finish) return;
        if (result === 1) {
            window.requestAnimationFrame(() => {
                const rightContent = document.querySelector('.mobile-iframe-content');
                rightContent?.scrollTo({ top: 0, behavior: 'smooth' });
            });
        } else if (result === 10) {
            window.requestAnimationFrame(() => {
                const currentCard = document.querySelector('.onboard-timeline-current .onboard-timeline-text > p');
                currentCard?.scrollIntoView({ behavior: 'smooth', block: 'end' });
                setTimeout(() => {
                    const rightContent = document.querySelector('.mobile-iframe-content');
                    rightContent?.scrollBy({ top: 90, behavior: 'smooth' });
                }, 220);
            });
        }
    }, [step, result, finish]);

    const finishSimulation = () => {
        endSimulation();
        setTimeout(() => {
            setFinish(true);
        }, 2000);

        setTimeout(() => {
            navigate('/login');
        }, 7000);
    };

    const rowRender = (number) => {
        let rows = getRow(number, rightPanelLang);
        let firstLeft = number % 2 !== 0;
        return (
            <div className={'onboard-timeline-row' + (firstLeft ? '' : '-rev')}>
                {rowLineRender(rows)}
            </div>
        );
    };

    const rowLineRender = (rows) => {
        let emptyCount = 0;
        rows?.forEach((row, i) => {
            if (row.title === '') emptyCount = emptyCount + 1;
        });
        return rows?.map((row, i) => {
            if (emptyCount === 3) return <div key={i} className="onboard-timeline-full-empty"></div>;
            if (row.title === '') return <div key={i} className="onboard-timeline-empty"></div>;
            return (
                <div key={i}
                     className={[result >= row.id ? 'onboard-timeline-active' : '', result === row.id ? 'onboard-timeline-current' : ''].filter(Boolean).join(' ')}>
                    {row.title !== '' && <div className="onboard-timeline-point"></div>}
                    <div className="onboard-timeline-text">
                        {row.title}
                        <p>{parse(row.content)}</p>
                    </div>
                </div>
            );
        });
    };

    return (
        <div>
            {!finish && (
                <>
                    <p className="information-tab-text">*Simülasyonu tamamlamak için aşağıdaki talimatları
                        uygulayın.</p>
                    <p className="simulation-continue-note">
                        {rightPanelLang === 'tr'
                            ? 'Simülasyona devam ediniz ve adımları sırayla tamamlayınız.'
                            : 'Continue the simulation and complete the steps in order.'}
                    </p>
                </>
            )}

            {!finish && step === 1 && (
                <div className="onboard-timeline-root">
                    {rowRender(1)}
                    <div className="onboard-timeline-edge"></div>
                    {rowRender(2)}
                    <div className="onboard-timeline-edge-row"></div>
                    {rowRender(3)}
                    <div className="onboard-timeline-edge-2"></div>
                    {rowRender(4)}
                </div>
            )}

            {!finish && step === 2 && (
                <div className="onboard-timeline-root">
                    {rowRender(5)}
                    <div className="onboard-timeline-edge"></div>
                    {rowRender(6)}
                    <div className="onboard-timeline-edge-row"></div>
                    {rowRender(7)}
                    {rowRender(8)}
                </div>
            )}

            {!finish && step === 3 && (
                <div className="onboard-timeline-root">
                    {rowRender(9)}
                    <div className="onboard-timeline-edge"></div>
                    {rowRender(10)}
                    <div className="onboard-timeline-edge-row"></div>
                    {rowRender(11)}
                    <div className="onboard-timeline-edge-2"></div>
                    {rowRender(12)}
                </div>
            )}

            {!finish && step === 4 && (
                <div className="onboard-timeline-root">
                    {rowRender(13)}
                    <div className="onboard-timeline-edge"></div>
                    {rowRender(14)}
                    <div className="onboard-timeline-edge-row"></div>
                    {rowRender(15)}
                    <div className="onboard-timeline-edge-2"></div>
                    {rowRender(16)}
                </div>
            )}

            {
                finish && (
                    <div className="onboard-timeline-root">
                        <p style={{ textAlign: 'center' }}>
                            {rightPanelLang === 'tr'
                                ? 'Tebrikler simülasyon başarı ile tamamlandı.'
                                : 'Congratulations, the simulation was completed successfully.'}
                        </p>
                        <Lottie options={{
                            loop: false,
                            autoplay: true,
                            animationData: successLogo
                        }} height={200} width={200} />
                        <p style={{ textAlign: 'center', fontSize: '13px' }}>
                            {rightPanelLang === 'tr'
                                ? '*5 saniye içinde simülasyon sonlandırılacaktır.'
                                : '*The simulation will close in 5 seconds.'}
                        </p>
                    </div>
                )
            }
        </div>);
};

export default TimeLine;
